export default "__VITE_ASSET__oe70VHU6__"